module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/4_6fb6a9a9f50e59be888e4bc864e4c7e6.png";